import { trigger, state, stagger, animate, style, query, transition, keyframes, animateChild } from '@angular/animations';

export const blockTransition = trigger('blockTransition', [
	transition(':enter', [
		query('.block', style({ opacity: 0 }), { optional: true }),
		query('.block', stagger(150, [
			style({ transform: 'translateY(100px)' }),
			animate('1s cubic-bezier(.75,-0.48,.26,1.52)', style({ transform: 'translateY(0px)', opacity: 1 }))
		]), { optional: true })
	]),
	transition(':leave', [
		query('.block', stagger(100, [
			style({ transform: 'translateY(0px)', opacity: 1 }),
			animate('1s cubic-bezier(.75,-0.48,.26,1.52)', style({ transform: 'translateY(100px)', opacity: 0 }))
		]), { optional: true })
	])
]);
export const listAnimation = trigger('listAnimation', [
	transition(':enter', [
		query('@listItemAnimation', stagger('1000ms', animateChild()))
	]),
]);


export const listTransition = trigger('listTransition', [
	transition(':enter', [
		query('.listTransition', style({ opacity: 0 }), { optional: true }),
		query('.listTransition', stagger('150ms', [
			animate('1s ease-in', keyframes([
				style({
					opacity: 0, transform: 'translateX(-75px)', offset: 0
				}),
				style({
					opacity: .5, transform: 'translateX(35px)', offset: 0.3
				}),
				style({
					opacity: 1, transform: 'translateX(0)', offset: 1
				})
			]))
		]), { optional: true })
	])
]);


export const rotate = trigger('rotate', [
	state('1', style({ transform: 'rotate(180deg)' })),
	state('0', style({ transform: 'rotate(0deg)' })),
	transition('1 => 0', animate('300ms')),
	transition('0 => 1', animate('300ms'))
]);

export const fadeIn = trigger('fadeIn', [
	transition(':enter', [
		style({ opacity: 0 }),
		animate(600)
	])
]);

export const smoothHeight = trigger('smoothHeight', [
	transition('void <=> *', []),
	transition('* <=> *', [
		style({ height: '{{startHeight}}px', opacity: 0 }),
		animate('.5s ease'),
	], { params: { startHeight: 0 } })
]);
